import { Export, MagnifyingGlass, Plus } from '@phosphor-icons/react';
import { Button, Flex, Input, Segmented } from 'antd';
import { ListFilter } from '@components/ListFilter';
import type { FilterConfig } from '@components/ListFilter/types';
import { CustomerSearchInput } from '@page-components/crm/CustomerSearch';
import { IconSizes } from '@utility/constants/style-contants';

export type InventoryListToolbarProps = {
  imperial: boolean;
  onImperialChange: (imperial: boolean) => void;
  listFilters: FilterConfig[];
  filter: Record<string, unknown>;
  setFilter: (next: Record<string, unknown>) => void;
  onExport: () => void;
  onAddInventory: () => void;
  onCustomerSelect: (customer: { customerOrganizationId: string }) => void;
  search: string;
  onSearchChange: (value: string) => void;
};

export function InventoryListToolbar({
  imperial,
  onImperialChange,
  listFilters,
  filter,
  setFilter,
  onExport,
  onAddInventory,
  onCustomerSelect,
  search,
  onSearchChange,
}: InventoryListToolbarProps) {
  return (
    <Flex align="center" justify="space-between" gap={16} style={{ width: '100%' }}>
      <Segmented
        value={imperial ? 'imperial' : 'metric'}
        onChange={value => onImperialChange(value === 'imperial')}
        options={[
          { label: 'Metric', value: 'metric' },
          { label: 'Imperial', value: 'imperial' },
        ]}
      />
      <Flex align="center" gap={8} wrap="nowrap">
        <ListFilter filters={listFilters} filter={filter} setFilter={setFilter} />
        <Button icon={<Export size={16} />} onClick={onExport}>
          Export
        </Button>
        <Button type="primary" icon={<Plus size={16} />} onClick={onAddInventory}>
          Inventory
        </Button>
        <CustomerSearchInput
          inputClassName="mr-2"
          onResultClick={onCustomerSelect}
          style={undefined}
          size={undefined}
          refreshKey={undefined}
        />
        <Input
          value={search}
          onChange={e => onSearchChange(e.target.value)}
          placeholder="Search title, SKU..."
          allowClear
          prefix={<MagnifyingGlass size={IconSizes.small} />}
          style={{ width: 200 }}
        />
      </Flex>
    </Flex>
  );
}
